import { NavLink } from "react-router-dom";
import { X } from "lucide-react";
import NavItem from "./NavItem";

interface SidebarProps {
  open: boolean;
  onClose: () => void;
  isHome: boolean;
  learnMode: boolean;
}

const Sidebar = ({ open, onClose, isHome, learnMode }: SidebarProps) => {
  return (
    <>
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black/60 z-40 transition-opacity ${
          open ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={onClose}
      />

      {/* Sidebar Panel */}
      <aside
        className={`fixed top-0 left-0 h-full w-72 
        bg-[#0E2F36] text-white 
        z-50 transform transition-transform duration-300
        ${open ? "translate-x-0" : "-translate-x-full"}`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 h-16 border-b border-white/20">
          <span className="font-semibold text-lg text-white">
            Menu
          </span>
          <button onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        {/* Nav */}
        <nav className="flex flex-col gap-4 px-5 py-6 text-white/80">
          <NavItem label="Home" sectionId="home" />

          {isHome && !learnMode && (
            <>
              <NavItem label="About" sectionId="about" />
              <NavItem label="Innovation" sectionId="innovation" />
              <NavItem label="Blog" sectionId="blog" />
              <NavItem label="Testimony" sectionId="testimony" />
              <NavItem label="Contact" sectionId="contact" />
            </>
          )}

          {(learnMode || !isHome) && (
            <>
              <NavLink
                to="/products"
                onClick={onClose}
                className="sidebar-link"
              >
                Product Gallery
              </NavLink>

              <NavLink
                to="/ImageGallery"
                onClick={onClose}
                className="sidebar-link"
              >
                Image Gallery
              </NavLink>

              <NavLink
                to="/ourProcess"
                onClick={onClose}
                className="sidebar-link"
              >
                Our Process
              </NavLink>
            </>
          )}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;